// Dates calendaires (YYYY-MM-DD, fuseau local) et « journée logique » qui finit à 4 h du matin.
window.toYYYYMMDD = function(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + "-" + m + "-" + d;
};
// Fin de journée à 4 h du matin : une révision terminée entre minuit et 4 h compte pour la veille (série, programme du
// jour, retards, minuteur, activité). Les dates de planification restent des dates calendaires.
window.DAY_END_HOUR = 4;
// window.__maintenant (chaîne ISO) : point d'appui des tests, posé par le serveur simulé pour figer « aujourd'hui »
// sans fausser les minuteurs du navigateur ; absent en production.
window.todayLogical = function() { var d = window.__maintenant ? new Date(window.__maintenant) : new Date(); d.setHours(d.getHours() - window.DAY_END_HOUR); d.setHours(0, 0, 0, 0); return d; };
window.todayStr = function() { return window.toYYYYMMDD(window.todayLogical()); };

window.parseDateLocal = function(dateStr) {
    if (!dateStr) return new Date();
    var p = dateStr.split('-');
    return new Date(p[0], p[1] - 1, p[2]);
};

window.formatDateFr = function(ymd) {
    if (!ymd) return '—';
    try {
        var d = window.parseDateLocal(ymd), o = { weekday: 'short', day: 'numeric', month: 'long' };
        if (d.getFullYear() !== window.todayLogical().getFullYear()) o.year = 'numeric'; // une date d'une autre année le dit
        return d.toLocaleDateString('fr-FR', o);
    }
    catch (e) { return ymd; }
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const toYYYYMMDD = window.toYYYYMMDD;
export const DAY_END_HOUR = window.DAY_END_HOUR;
export const todayLogical = window.todayLogical;
export const todayStr = window.todayStr;
export const parseDateLocal = window.parseDateLocal;
export const formatDateFr = window.formatDateFr;
